import React, { useEffect, useState } from "react";
import LoadingWell from "../../components/Loading/LoadingWell";
import { Link, useLocation } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";

import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import DarkModeButton from "../../components/DarkModeButton/DarkModeButton";
import "./Columns.css";

export default function Columns() {
  const location = useLocation();
  const [interviews, setInterviews] = useState([]);
  const [interviewsLoading, setInterviewsLoading] = useState(true);
  const [interviewsError, setInterviewsError] = useState(null);
  const [recommenders, setRecommenders] = useState([]);
  const [recommendersLoading, setRecommendersLoading] = useState(true);
  const [recommendersError, setRecommendersError] = useState(null);
  const [tens, setTens] = useState([]);
  const [tensLoading, setTensLoading] = useState(true);
  const [tensError, setTensError] = useState(null);
  const [travelDiaries, setTravelDiaries] = useState([]);
  const [travelDiariesLoading, setTravelDiariesLoading] = useState(true);
  const [travelDiariesError, setTravelDiariesError] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [reviewsLoading, setReviewsLoading] = useState(true);
  const [reviewsError, setReviewsError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const storageUrl = process.env.REACT_APP_STORAGE_URL;


  useEffect(() => {
      document.title = "Kútonline - Rovatok";
    }, []);
    
  // Scroll to hash after all content is loaded
  useEffect(() => {
    if (
      !interviewsLoading &&
      !recommendersLoading &&
      !tensLoading &&
      !travelDiariesLoading &&
      !reviewsLoading &&
      location.hash
    ) {
      // Timeout ensures DOM is updated
      setTimeout(() => {
        const id = location.hash.replace("#", "");
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
    }
  }, [
    interviewsLoading,
    recommendersLoading,
    tensLoading,
    travelDiariesLoading,
    reviewsLoading,
    location.hash
  ]);

  useEffect(() => {
    setInterviewsLoading(true);
    setInterviewsError(null);
    fetch(`${apiUrl}/posts/interviews`)
      .then(res => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then(data => {
        setInterviews(data);
        setInterviewsLoading(false);
      })
      .catch(err => {
        setInterviewsError(err.message);
        setInterviewsLoading(false);
      });

    setRecommendersLoading(true);
    setRecommendersError(null);
    fetch(`${apiUrl}/posts/recommenders`)
      .then(res => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then(data => {
        setRecommenders(data);
        setRecommendersLoading(false);
      })
      .catch(err => {
        setRecommendersError(err.message);
        setRecommendersLoading(false);
      });

    setTensLoading(true);
    setTensError(null);
    fetch(`${apiUrl}/posts/tens`)
      .then(res => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then(data => {
        setTens(data);
        setTensLoading(false);
      })
      .catch(err => {
        setTensError(err.message);
        setTensLoading(false);
      });

    setTravelDiariesLoading(true);
    setTravelDiariesError(null);
    fetch(`${apiUrl}/posts/travel-diaries`)
      .then(res => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then(data => {
        setTravelDiaries(data);
        setTravelDiariesLoading(false);
      })
      .catch(err => {
        setTravelDiariesError(err.message);
        setTravelDiariesLoading(false);
      });

    setReviewsLoading(true);
    setReviewsError(null);
    fetch(`${apiUrl}/posts/reviews`)
      .then(res => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then(data => {
        setReviews(data);
        setReviewsLoading(false);
      })
      .catch(err => {
        setReviewsError(err.message);
        setReviewsLoading(false);
      });
  }, [apiUrl]);

  return (
    <div>
      <Navbar />
      <DarkModeButton />

      <div className="page-container">
        <section className="columns-header">
          <div className="columns-intro-row">
            <div className="columns-intro-left">
              <h2 className="columns-rovatok">Rovatok</h2>
              <p>
                  Online újságunk változatos tartalmakat kínál, amelyeket különböző rovatokba rendeztünk, hogy az olvasók könnyen eligazodjanak és megtalálják a számukra érdekes témákat. Olvasóink számára elérhetők az <strong>Interjú</strong>, a <strong>10</strong>, a <strong>Szemle</strong>, az <strong>Ajánló</strong> és az <strong>Útinapló</strong> rovatok.
              </p>
            </div>
            <div className="columns-intro-right">
              <div className="columns-toc-container column-list">
                <h3>Tartalomjegyzék:</h3>
                <ul className="columns-link">
                  <li>
                    <Link to="/columns#interview">Interjú</Link>
                  </li>
                  <li>
                    <Link to="/columns#recommender">Ajánló</Link>
                  </li>
                  <li>
                    <Link to="/columns#10">10</Link>
                  </li>
                  <li>
                    <Link to="/columns#travel_diary">Útinapló</Link>
                  </li>
                  <li>
                    <Link to="/columns#review">Szemle</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="columns">
          <h3 id="interview">Interjú</h3>
          <p>Izgalmas interjúk minden korosztálynak.</p>
          <div className="posts interviews">
            {interviewsLoading ? (
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 100, maxWidth: 150, maxHeight: 150}}>
                <LoadingWell />
              </div>
            ) : interviewsError ? (
              <div style={{color: 'red', textAlign: 'center', margin: 24}}>
                Az intejúk betöltése sikertelen kérjük próbálja újra később!
              </div>
            ) : (
              interviews.map(post => (
                <Link key={post.id} to={`/article/${post.slug}`}>
                  <img src={`${storageUrl}${post.thumbnail}`} alt={post.title} />
                  <span>{post.title}</span>
                </Link>
              ))
            )}
          </div>
        </section>

        <section className="columns">
          <h3 id="recommender">Ajánló</h3>
          <p>Programok, kiállítások, érdekességek…</p>
          <div className="posts recommenders">
            {recommendersLoading ? (
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',  minHeight: 100, maxWidth: 150, maxHeight: 150}}>
                <LoadingWell />
              </div>
            ) : recommendersError ? (
              <div style={{color: 'red', textAlign: 'center', margin: 24}}>
                Az ajánlók betöltése sikertelen, kérjük próbálja újra később!
              </div>
            ) : (
              recommenders.map(post => (
                <Link key={post.id} to={`/article/${post.slug}`}>
                  <img src={`${storageUrl}${post.thumbnail}`} alt={post.title} />
                  <span>{post.title}</span>
                </Link>
              ))
            )}
          </div>
        </section>

        <section className="columns">
          <h3 id="10">10</h3>
          <p>A 10 címet viselő rovatunkban minden cikk tíz darab érdekességet listáz.</p>
          <div className="posts 10s">
            {tensLoading ? (
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',  minHeight: 100, maxWidth: 150, maxHeight: 150}}>
                <LoadingWell />
              </div>
            ) : tensError ? (
              <div style={{color: 'red', textAlign: 'center', margin: 24}}>
                A "10 dolog" betöltése sikertelen, kérjük próbálja újra később!
              </div>
            ) : (
              tens.map(post => (
                <Link key={post.id} to={`/article/${post.slug}`}>
                  <img src={`${storageUrl}${post.thumbnail}`} alt={post.title} />
                  <span>{post.title}</span>
                </Link>
              ))
            )}
          </div>
        </section>

        <section className="columns">
          <h3 id="travel_diary">
            Útinapló<span className="columns-subtitle">– avagy a gyűjtőutak valósága és kalandjai a múlt századtól napjainkig.</span>
          </h3>
          <p>Ebben a rovatban olyan beszámolók és leírások sora olvasható, amelyek eseményei felejthetetlen élmények maradtak…</p>
            <div className="posts travel_diaries">
            {travelDiariesLoading ? (
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',  minHeight: 100, maxWidth: 150, maxHeight: 150}}>
                <LoadingWell />
              </div>
            ) : travelDiariesError ? (
              <div style={{color: 'red', textAlign: 'center', margin: 24}}>
                Az útinaplók betöltése sikertelen, kérjük próbálja újra később!
              </div>
            ) : (
              travelDiaries.map(post => (
                <Link key={post.id} to={`/article/${post.slug}`}>
                  <img src={`${storageUrl}${post.thumbnail}`} alt={post.title} />
                  <span>{post.title}</span>
                </Link>
              ))
            )}
          </div>
        </section>

        <section className="columns">
          <h3 id="review">Szemle</h3>
          <p>A Szemle cikkeiben egy-egy szakmai kiadvány, tanulmány bemutatásával foglalkozunk.</p>
          <div className="posts reviews">
            {reviewsLoading ? (
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',  minHeight: 100, maxWidth: 150, maxHeight: 150}}>
                <LoadingWell />
              </div>
            ) : reviewsError ? (
              <div style={{color: 'red', textAlign: 'center', margin: 24}}>
                A szemle cikkek betöltése sikertelen, kérjük próbálja újra később!
              </div>
            ) : (
              reviews.map(post => (
                <Link key={post.id} to={`/article/${post.slug}`}>
                  <img src={`${storageUrl}${post.thumbnail}`} alt={post.title} />
                  <span>{post.title}</span>
                </Link>
              ))
            )}
          </div>
        </section>
      </div>

      <ScrollToTopButton />
    </div>
  );
}